import React from "react";
import { useNavigate } from "react-router-dom";

function Breadcrumbs({ items }) {
  const navigate = useNavigate();

  return (
    <nav aria-label="breadcrumb" style={{ padding: "0 0 20px", width: "100%", display: "flex" }}>
      <ol style={{
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        alignItems: "center",
        fontSize: "14px",
        fontWeight: "500",
        color: "rgb(203, 213, 225)",
        flexWrap: "wrap",
        gap: "4px 0"
      }}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <React.Fragment key={index}>
              <li>
                {isLast ? (
                  <span style={{ color: "#000", textTransform: "capitalize", fontWeight: "600" }}>
                    {item.label}
                  </span>
                ) : (
                  <span
                    onClick={() => navigate(item.path)}
                    style={{ cursor: "pointer", color: "rgb(203, 213, 225)", transition: "color 0.2s" }}
                    onMouseEnter={(e) => e.target.style.color = "#ff8c00"}
                    onMouseLeave={(e) => e.target.style.color = "rgb(203, 213, 225)"}
                  >
                    {item.label}
                  </span>
                )}
              </li>
              {!isLast && (
                <li style={{ margin: "0 10px", color: "rgb(203, 213, 225)" }}>/</li>
              )}
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
